export default {
  items: [],
  pagination: {},
  filter: {},
  isBusy: {},
};
